/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface Call
 */
export interface Call {
    /**
     * 
     * @type {string}
     * @memberof Call
     */
    tenantId?: string;
    /**
     * 
     * @type {string}
     * @memberof Call
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof Call
     */
    uuid?: string;
    /**
     * 
     * @type {string}
     * @memberof Call
     */
    description?: string;
    /**
     * 
     * @type {any}
     * @memberof Call
     */
    includeControls?: any | null;
    /**
     * 
     * @type {string}
     * @memberof Call
     */
    href?: string;
    /**
     * 
     * @type {string}
     * @memberof Call
     */
    controlId?: string;
    /**
     * 
     * @type {string}
     * @memberof Call
     */
    subControlId?: string;
}

/**
 * Check if a given object implements the Call interface.
 */
export function instanceOfCall(value: object): value is Call {
    return true;
}

export function CallFromJSON(json: any): Call {
    return CallFromJSONTyped(json, false);
}

export function CallFromJSONTyped(json: any, ignoreDiscriminator: boolean): Call {
    if (json == null) {
        return json;
    }
    return {
        
        'tenantId': json['tenantId'] == null ? undefined : json['tenantId'],
        'id': json['id'] == null ? undefined : json['id'],
        'uuid': json['uuid'] == null ? undefined : json['uuid'],
        'description': json['description'] == null ? undefined : json['description'],
        'includeControls': json['includeControls'] == null ? undefined : json['includeControls'],
        'href': json['href'] == null ? undefined : json['href'],
        'controlId': json['controlId'] == null ? undefined : json['controlId'],
        'subControlId': json['subControlId'] == null ? undefined : json['subControlId'],
    };
}

export function CallToJSON(json: any): Call {
    return CallToJSONTyped(json, false);
}

export function CallToJSONTyped(value?: Call | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'tenantId': value['tenantId'],
        'id': value['id'],
        'uuid': value['uuid'],
        'description': value['description'],
        'includeControls': value['includeControls'],
        'href': value['href'],
        'controlId': value['controlId'],
        'subControlId': value['subControlId'],
    };
}

